import { gql } from "@apollo/client";

export const GET_ASSET_SALES_PRICE = gql`
    query GetLegacyNextAssetSalesPrice($id: String!) {
        getLegacyNextAssetSalesPrice(id: $id) {
            bfe
            salesPrice
            currency
            salesDate
        }
    }
`;
